import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { CharacterSimpleFormContent } from "./components/CharacterSimpleFormContent";

export function CharacterCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <CharacterSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
